import React from 'react';
import styles from './ServicioSuscripcion.module.css';
import subscription from '../../assets/images/suscripciones.jpg';

export default function ServicioSuscripcion() {
  return (
    <section className={styles.root} aria-label="Servicio de suscripción">
      <div className={styles.inner}>
        <div className={styles.media}>
          <img
            className={styles.image}
            src={subscription}
            alt="Servicio de suscripción"
            loading="lazy"
          />
        </div>

        <div className={styles.text}>
          <h2 className={styles.title}>Servicio de suscripción</h2>
          <p className={styles.lead}>
            Es ideal para comercio o empresas de servicios que manejan  cobros recurrentes  de planes  y suscripciones.
          </p>
        </div>
      </div>
    </section>
  );
}